import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';

export const HomeApp: ComponentType<unknown> & LoadableExport.LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "home-app-entry" */ '../App'),
	loading: () => null,
});
